// Simple translation utility for MATE Korean Learning Profile Survey
// Supports English and Indonesian languages

export type Language = 'en' | 'id';

// Dictionary of translations using English sentences as keys
export const translations: Record<string, Record<Language, string>> = {
    // Header
    "Korean Learning Profile Survey": {
        en: "Korean Learning Profile Survey",
        id: "Survei Profil Belajar Bahasa Korea"
    },
    "Talk and Learn Korean": {
        en: "Talk and Learn Korean",
        id: "Talk and Learn Korean"
    },
    "Your responses will help us tailor our Korean language sessions to your specific needs and learning goals. All information provided will be kept confidential and used only for educational purposes.": {
        en: "Your responses will help us tailor our Korean language sessions to your specific needs and learning goals. All information provided will be kept confidential and used only for educational purposes.",
        id: "Jawaban Anda akan membantu kami menyesuaikan sesi belajar bahasa Korea dengan kebutuhan dan tujuan belajar Anda. Semua informasi yang diberikan akan dijaga kerahasiaannya dan hanya digunakan untuk tujuan pendidikan."
    },
    
    // Personal Information
    "Personal Information": {
        en: "Personal Information",
        id: "Personal Information"
    },
    "Full Name": {
        en: "Full Name",
        id: "Nama Lengkap"
    },
    "Email Address": {
        en: "Email Address",
        id: "Alamat Email"
    },
    "Phone Number": {
        en: "Phone Number",
        id: "Nomor Telepon"
    },
    "Age": {
        en: "Age",
        id: "Usia"
    },
    "Select your age range": {
        en: "Select your age range",
        id: "Pilih rentang usia Anda"
    },
    "Under 18": {
        en: "Under 18",
        id: "Di bawah 18"
    },
    "18-24": {
        en: "18-24",
        id: "18-24"
    },
    "25-34": {
        en: "25-34",
        id: "25-34"
    },
    "35-44": {
        en: "35-44",
        id: "35-44"
    },
    "45-54": {
        en: "45-54",
        id: "45-54"
    },
    "55+": {
        en: "55+",
        id: "55+"
    },
    "Country of Residence": {
        en: "Country of Residence",
        id: "Negara Tempat Tinggal"
    },
    "Your Timezone": {
        en: "Your Timezone",
        id: "Zona Waktu Anda"
    },
    "e.g. GMT+8, EST, etc.": {
        en: "e.g. GMT+8, EST, etc.",
        id: "contoh: GMT+7, WIB, dll."
    },
    
    // Language Background
    "Language Background": {
        en: "Language Background",
        id: "Language Background"
    },
    "Native Language": {
        en: "Native Language",
        id: "Bahasa Ibu"
    },
    "Other Languages You Speak": {
        en: "Other Languages You Speak",
        id: "Bahasa Lain yang Anda Kuasai"
    },
    "List any other languages you speak and your proficiency level": {
        en: "List any other languages you speak and your proficiency level",
        id: "Sebutkan bahasa lain yang Anda kuasai dan tingkat kemahiran Anda"
    },
    "Current Korean Language Level": {
        en: "Current Korean Language Level",
        id: "Tingkat Bahasa Korea Saat Ini"
    },
    "Select your level": {
        en: "Select your level",
        id: "Pilih tingkat Anda"
    },
    "Absolute Beginner (No knowledge)": {
        en: "Absolute Beginner (No knowledge)",
        id: "Pemula Absolut (Tidak memiliki pengetahuan)"
    },
    "Beginner (Know Hangul, basic greetings)": {
        en: "Beginner (Know Hangul, basic greetings)",
        id: "Pemula (Mengenal Hangul, salam dasar)"
    },
    "Elementary (Simple conversations, basic grammar)": {
        en: "Elementary (Simple conversations, basic grammar)",
        id: "Dasar (Percakapan sederhana, tata bahasa dasar)"
    },
    "Intermediate (Can discuss familiar topics)": {
        en: "Intermediate (Can discuss familiar topics)",
        id: "Menengah (Dapat mendiskusikan topik yang familiar)"
    },
    "Advanced (Fluent in most situations)": {
        en: "Advanced (Fluent in most situations)",
        id: "Lanjutan (Lancar dalam kebanyakan situasi)"
    },
    "Native/Bilingual": {
        en: "Native/Bilingual",
        id: "Penutur Asli/Bilingual"
    },
    "Have you studied Korean before?": {
        en: "Have you studied Korean before?",
        id: "Apakah Anda pernah belajar bahasa Korea sebelumnya?"
    },
    "Yes": {
        en: "Yes",
        id: "Ya"
    },
    "No": {
        en: "No",
        id: "Tidak"
    },
    "If yes, please describe your previous Korean learning experience:": {
        en: "If yes, please describe your previous Korean learning experience:",
        id: "Jika ya, jelaskan pengalaman belajar bahasa Korea Anda sebelumnya:"
    },
    "Describe any courses, self-study, tutoring, etc.": {
        en: "Describe any courses, self-study, tutoring, etc.",
        id: "Jelaskan kursus, belajar mandiri, bimbingan, dll."
    },
    
    // Learning Goals
    "Learning Goals & Motivation": {
        en: "Learning Goals & Motivation",
        id: "Learning Goals & Motivation"
    },
    "Why do you want to learn Korean? (Select all that apply)": {
        en: "Why do you want to learn Korean? (Select all that apply)",
        id: "Mengapa Anda ingin belajar bahasa Korea? (Pilih semua yang sesuai)"
    },
    "Travel to Korea": {
        en: "Travel to Korea",
        id: "Bepergian ke Korea"
    },
    "K-pop/K-drama interest": {
        en: "K-pop/K-drama interest",
        id: "Minat K-pop/K-drama"
    },
    "Business/Professional": {
        en: "Business/Professional",
        id: "Bisnis/Profesional"
    },
    "Academic purposes": {
        en: "Academic purposes",
        id: "Tujuan akademis"
    },
    "Korean family/heritage": {
        en: "Korean family/heritage",
        id: "Keluarga/warisan Korea"
    },
    "Korean friends/relationship": {
        en: "Korean friends/relationship",
        id: "Teman/hubungan dengan orang Korea"
    },
    "Other": {
        en: "Other",
        id: "Lainnya"
    },
    "What specific skills would you like to focus on?": {
        en: "What specific skills would you like to focus on?",
        id: "Keterampilan spesifik apa yang ingin Anda fokuskan?"
    },
    "Speaking/Conversation": {
        en: "Speaking/Conversation",
        id: "Berbicara/Percakapan"
    },
    "Listening Comprehension": {
        en: "Listening Comprehension",
        id: "Pemahaman Mendengarkan"
    },
    "Reading": {
        en: "Reading",
        id: "Membaca"
    },
    "Writing": {
        en: "Writing",
        id: "Menulis"
    },
    "Grammar": {
        en: "Grammar",
        id: "Tata Bahasa"
    },
    "Vocabulary Building": {
        en: "Vocabulary Building",
        id: "Membangun Kosakata"
    },
    "Cultural Understanding": {
        en: "Cultural Understanding",
        id: "Pemahaman Budaya"
    },
    "What is your timeframe for achieving your Korean language goals?": {
        en: "What is your timeframe for achieving your Korean language goals?",
        id: "Berapa jangka waktu Anda untuk mencapai tujuan belajar bahasa Korea?"
    },
    "Select a timeframe": {
        en: "Select a timeframe",
        id: "Pilih jangka waktu"
    },
    "1-3 months": {
        en: "1-3 months",
        id: "1-3 bulan"
    },
    "3-6 months": {
        en: "3-6 months",
        id: "3-6 bulan"
    },
    "6-12 months": {
        en: "6-12 months",
        id: "6-12 bulan"
    },
    "1-2 years": {
        en: "1-2 years",
        id: "1-2 tahun"
    },
    "Long-term learning (2+ years)": {
        en: "Long-term learning (2+ years)",
        id: "Pembelajaran jangka panjang (2+ tahun)"
    },
    "What motivates you to continue learning even when it gets difficult?": {
        en: "What motivates you to continue learning even when it gets difficult?",
        id: "Apa yang memotivasi Anda untuk terus belajar bahkan ketika menjadi sulit?"
    },
    
    // Learning Preferences
    "Learning Preferences": {
        en: "Learning Preferences",
        id: "Learning Preferences"
    },
    "How would you describe your learning style?": {
        en: "How would you describe your learning style?",
        id: "Bagaimana Anda menggambarkan gaya belajar Anda?"
    },
    "Visual (learning through images, videos, diagrams)": {
        en: "Visual (learning through images, videos, diagrams)",
        id: "Visual (belajar melalui gambar, video, diagram)"
    },
    "Auditory (learning through listening and speaking)": {
        en: "Auditory (learning through listening and speaking)",
        id: "Auditori (belajar melalui mendengarkan dan berbicara)"
    },
    "Reading/Writing (learning through text and notes)": {
        en: "Reading/Writing (learning through text and notes)",
        id: "Membaca/Menulis (belajar melalui teks dan catatan)"
    },
    "Kinesthetic (learning through practice and experience)": {
        en: "Kinesthetic (learning through practice and experience)",
        id: "Kinestetik (belajar melalui praktik dan pengalaman)"
    },
    "How much time can you dedicate to studying Korean per week?": {
        en: "How much time can you dedicate to studying Korean per week?",
        id: "Berapa banyak waktu yang dapat Anda dedikasikan untuk belajar bahasa Korea per minggu?"
    },
    "Select time commitment": {
        en: "Select time commitment",
        id: "Pilih komitmen waktu"
    },
    "Less than 1 hour": {
        en: "Less than 1 hour",
        id: "Kurang dari 1 jam"
    },
    "1-3 hours": {
        en: "1-3 hours",
        id: "1-3 jam"
    },
    "4-7 hours": {
        en: "4-7 hours",
        id: "4-7 jam"
    },
    "8+ hours": {
        en: "8+ hours",
        id: "8+ jam"
    },
    "Preferred session frequency:": {
        en: "Preferred session frequency:",
        id: "Frekuensi sesi yang disukai:"
    },
    "Select frequency": {
        en: "Select frequency",
        id: "Pilih frekuensi"
    },
    "Once a week": {
        en: "Once a week",
        id: "Sekali seminggu"
    },
    "Twice a week": {
        en: "Twice a week",
        id: "Dua kali seminggu"
    },
    "Three times a week": {
        en: "Three times a week",
        id: "Tiga kali seminggu"
    },
    "Daily": {
        en: "Daily",
        id: "Setiap hari"
    },
    "Flexible/As needed": {
        en: "Flexible/As needed",
        id: "Fleksibel/Sesuai kebutuhan"
    },
    "Preferred learning approach:": {
        en: "Preferred learning approach:",
        id: "Pendekatan belajar yang disukai:"
    },
    "Structured (following a curriculum, textbook-based)": {
        en: "Structured (following a curriculum, textbook-based)",
        id: "Terstruktur (mengikuti kurikulum, berbasis buku teks)"
    },
    "Conversational (learning through natural dialogue)": {
        en: "Conversational (learning through natural dialogue)",
        id: "Percakapan (belajar melalui dialog alami)"
    },
    "Mixed approach": {
        en: "Mixed approach",
        id: "Pendekatan campuran"
    },
    
    // Cultural Interests
    "Cultural Interests": {
        en: "Cultural Interests",
        id: "Cultural Interests"
    },
    "Which aspects of Korean culture interest you? (Select all that apply)": {
        en: "Which aspects of Korean culture interest you? (Select all that apply)",
        id: "Aspek budaya Korea mana yang menarik minat Anda? (Pilih semua yang sesuai)"
    },
    "K-pop": {
        en: "K-pop",
        id: "K-pop"
    },
    "K-dramas": {
        en: "K-dramas",
        id: "K-drama"
    },
    "Korean Cuisine": {
        en: "Korean Cuisine",
        id: "Masakan Korea"
    },
    "History": {
        en: "History",
        id: "Sejarah"
    },
    "Literature": {
        en: "Literature",
        id: "Sastra"
    },
    "Business Culture": {
        en: "Business Culture",
        id: "Budaya Bisnis"
    },
    "Traditional Culture": {
        en: "Traditional Culture",
        id: "Budaya Tradisional"
    },
    "Modern Society": {
        en: "Modern Society",
        id: "Masyarakat Modern"
    },
    "Do you have any favorite Korean media (shows, music, films) that you'd like to incorporate into your learning?": {
        en: "Do you have any favorite Korean media (shows, music, films) that you'd like to incorporate into your learning?",
        id: "Apakah Anda memiliki media Korea favorit (acara, musik, film) yang ingin Anda masukkan ke dalam pembelajaran Anda?"
    },
    
    // Additional Information
    "Additional Information": {
        en: "Additional Information",
        id: "Additional Information"
    },
    "Do you have any concerns or challenges with language learning that we should be aware of?": {
        en: "Do you have any concerns or challenges with language learning that we should be aware of?",
        id: "Apakah Anda memiliki kekhawatiran atau tantangan dalam belajar bahasa yang perlu kami ketahui?"
    },
    "What are your expectations for these Korean language sessions?": {
        en: "What are your expectations for these Korean language sessions?",
        id: "Apa harapan Anda untuk sesi belajar bahasa Korea ini?"
    },
    "Any other information you'd like to share with your tutor?": {
        en: "Any other information you'd like to share with your tutor?",
        id: "Informasi lain yang ingin Anda bagikan dengan tutor Anda?"
    },
    
    // Korean Learning Options
    "Choose Your Korean Learning Option": {
        en: "Choose Your Korean Learning Option",
        id: "Pilih Opsi Pembelajaran Bahasa Korea Anda"
    },
    "One-time 1-on-1 Session": {
        en: "One-time 1-on-1 Session",
        id: "Sesi 1-on-1 Satu Kali"
    },
    "Ask for price": {
        en: "Ask for price",
        id: "Tanyakan harga"
    },
    "Individual Korean language session with a tutor": {
        en: "Individual Korean language session with a tutor",
        id: "Sesi bahasa Korea individual dengan tutor"
    },
    "Recommended for:": {
        en: "Recommended for:",
        id: "Direkomendasikan untuk:"
    },
    "Those preparing travel in Korea": {
        en: "Those preparing travel in Korea",
        id: "Mereka yang mempersiapkan perjalanan ke Korea"
    },
    "Example: Discuss your 3-night/4-day Korean tour plan and get recommendations for buying cosmetics at Olive Young in a 30-minute session.": {
        en: "Example: Discuss your 3-night/4-day Korean tour plan and get recommendations for buying cosmetics at Olive Young in a 30-minute session.",
        id: "Contoh: Diskusikan rencana tur Korea 3-malam/4-hari Anda dan dapatkan rekomendasi untuk membeli kosmetik di Olive Young dalam sesi 30 menit."
    },
    "Prep Session for Multiple 1-on-1": {
        en: "Prep Session for Multiple 1-on-1",
        id: "Sesi Persiapan untuk Beberapa Sesi 1-on-1"
    },
    "Preparation sessions to maximize your learning": {
        en: "Preparation sessions to maximize your learning",
        id: "Sesi persiapan untuk memaksimalkan pembelajaran Anda"
    },
    "Those preparing TOPIK, study abroad, etc.": {
        en: "Those preparing TOPIK, study abroad, etc.",
        id: "Mereka yang mempersiapkan TOPIK, studi di luar negeri, dll."
    },
    "Example: We will examine your current level and plan 4-12 sessions to help you achieve your Korean language goals.": {
        en: "Example: We will examine your current level and plan 4-12 sessions to help you achieve your Korean language goals.",
        id: "Contoh: Kami akan mengevaluasi tingkat Anda saat ini dan merencanakan 4-12 sesi untuk membantu Anda mencapai tujuan bahasa Korea Anda."
    },
    "4 Week In-a-row, 1-on-6 Session": {
        en: "4 Week In-a-row, 1-on-6 Session",
        id: "Sesi 1-on-6 4 Minggu Berturut-turut"
    },
    "Four consecutive weeks of group sessions": {
        en: "Four consecutive weeks of group sessions",
        id: "Empat minggu berturut-turut sesi kelompok"
    },
    "Consistent learners seeking group interaction": {
        en: "Consistent learners seeking group interaction",
        id: "Pembelajar konsisten yang mencari interaksi kelompok"
    },
    "Example: Join a group of Day6 fans for Korean song lessons and engaging conversations about Korean culture.": {
        en: "Example: Join a group of Day6 fans for Korean song lessons and engaging conversations about Korean culture.",
        id: "Contoh: Bergabunglah dengan grup penggemar Day6 untuk pelajaran lagu Korea dan percakapan menarik tentang budaya Korea."
    },
    
    // Button & Footer
    "Submit Survey": {
        en: "Submit Survey",
        id: "Submit Survey"
    },
    "Thank you for taking the time to complete this survey. Your responses will help us create a personalized learning experience for you.": {
        en: "Thank you for taking the time to complete this survey. Your responses will help us create a personalized learning experience for you.",
        id: "Terima kasih telah meluangkan waktu untuk mengisi survei ini. Jawaban Anda akan membantu kami menciptakan pengalaman belajar yang dipersonalisasi untuk Anda."
    },
    "Thank you for submitting your profile! Your tutor will review this information before your first session.": {
        en: "Thank you for submitting your profile! Your tutor will review this information before your first session.",
        id: "Terima kasih telah mengirimkan profil Anda! Tutor Anda akan meninjau informasi ini sebelum sesi pertama Anda."
    },
    
    // Survey Submitted Page
    "Survey Submitted Successfully!": {
        en: "Survey Submitted Successfully!",
        id: "Survei Berhasil Dikirim!"
    },
    "Thank you for submitting your Korean Learning Profile. Your tutor will review this information before your first session.": {
        en: "Thank you for submitting your Korean Learning Profile. Your tutor will review this information before your first session.",
        id: "Terima kasih telah mengirimkan Profil Belajar Bahasa Korea Anda. Tutor Anda akan meninjau informasi ini sebelum sesi pertama Anda."
    },
    "You'll be contacted soon with next steps for your Korean language journey.": {
        en: "You'll be contacted soon with next steps for your Korean language journey.",
        id: "Anda akan segera dihubungi untuk langkah selanjutnya dalam perjalanan belajar bahasa Korea Anda."
    },
    "What's Next?": {
        en: "What's Next?",
        id: "Apa Selanjutnya?"
    },
    "Your tutor will review your profile": {
        en: "Your tutor will review your profile",
        id: "Tutor Anda akan meninjau profil Anda"
    },
    "You'll receive a confirmation email within 24-48 hours": {
        en: "You'll receive a confirmation email within 24-48 hours",
        id: "Anda akan menerima email konfirmasi dalam waktu 24-48 jam"
    },
    "We'll schedule your first session based on your preferences": {
        en: "We'll schedule your first session based on your preferences",
        id: "Kami akan menjadwalkan sesi pertama Anda berdasarkan preferensi Anda"
    },
    "If you have any questions, please contact us at:": {
        en: "If you have any questions, please contact us at:",
        id: "Jika Anda memiliki pertanyaan, silakan hubungi kami di:"
    },
    "Return to Home": {
        en: "Return to Home",
        id: "Kembali ke Beranda"
    },
    "We look forward to helping you on your Korean language journey.": {
        en: "We look forward to helping you on your Korean language journey.",
        id: "Kami menantikan untuk membantu Anda dalam perjalanan belajar bahasa Korea."
    }
};

// Translation function to get text in the selected language
export const translate = (key: string, language: Language): string => {
    if (!translations[key]) {
        //console.warn(`Translation key not found: ${key}`);
        return key;
    }
    return translations[key][language] || key;
};